import {
  FETCH_PAGE_DATA_REQUEST,
  FETCH_PAGE_DATA_SUCCESS,
  FETCH_PAGE_DATA_FAILURE,
} from '../actions/actionTypes';

export const makeAssetReducer = ({ assetName, dataKey, initialData = null }) => {
  const initialState = {
    data: initialData,
    settings: { pending: true, loaded: false, error: false },
  };

  return (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PAGE_DATA_REQUEST: {
        if (!action.payload.assets.includes(assetName)) return state;

        return { ...state, settings: { ...state.settings, pending: true, error: false } };
      }
      case FETCH_PAGE_DATA_SUCCESS: {
        if (!(dataKey in action.payload.data)) return state;

        return {
          data: action.payload.data[dataKey],
          settings: { pending: false, loaded: true, error: false },
        };
      }
      case FETCH_PAGE_DATA_FAILURE: {
        if (!action.payload.assets.includes(assetName)) return state;

        return { ...state, settings: { ...state.settings, pending: false, error: true } };
      }
      default:
        return state;
    }
  };
};
